<style scoped>
	@import '../../assets/css/maintenance.css';
</style>

<template>
	<div class="maintenance-container">
		<div class="maintenance-box">
			<img src="../../assets/img/app/logo.png" class="login-logo"/>
			<h1>{{title}}</h1>
			<p v-html="content"></p>
		</div>
	</div>
</template>

<script>
	
	import {maintenance} from '@/system/model/auth';
	
	export default{
		data(){
			return{
				title: '',
				content: ''
			}
		},created:function(){
			var result = maintenance();
			var self = this;
			result.then(function(value){
				if(value.valid){
					self.title = value.data.page_detail.title;
					self.content = value.data.page_detail.content;
				}else{
					self.$router.push('/nofound');
				}
			});
		}
	}
</script>

